import { Component } from '@angular/core';
import { ConfigManagerPropertiesEnum } from '../../enums/config-manager-properties.enum';
import { ConfigManagerService } from '@xpo-ltl/config-manager';

@Component({
  selector: 'app-region-banner',
  templateUrl: './region-banner.component.html',
  styleUrls: ['./region-banner.component.scss'],
})
export class RegionBannerComponent {
  constructor(private configManagerService: ConfigManagerService) {}

  get isProd(): boolean {
    return this.configManagerService.getSetting<boolean>(ConfigManagerPropertiesEnum.Production);
  }

  get region(): string {
    return this.configManagerService.getSetting<string>(ConfigManagerPropertiesEnum.Region);
  }
}
